var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 13,
    fill: "#00B42A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 9.5,
    fill: "#FF7D00"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 40.5,
    r: 5.5,
    fill: "#C8A1FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 28.5,
    r: 7.5,
    fill: "#4285F4"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 51.5,
    r: 10.5,
    fill: "#F53F3F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/bubble.e5a889fb1c64fde2e70971cc8b7c6f0d.svg";
export { ForwardRef as ReactComponent };